import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AudioService {
  private audioEl: HTMLAudioElement;
  private unlocked = false;
  private audioCtx: AudioContext;
  private analyser: AnalyserNode;

  constructor() {
    this.audioEl = new Audio();
    this.audioEl.preload = 'auto';

    this.audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();
    this.analyser = this.audioCtx.createAnalyser();
    const srcNode = this.audioCtx.createMediaElementSource(this.audioEl);
    srcNode.connect(this.analyser);
    this.analyser.connect(this.audioCtx.destination);

    this.audioEl.onended = () => {
      console.log('Agent stopped speaking');
    };
  }

  /** Unlocks audio on first user gesture */
  public unlock(): Promise<void> {
    if (this.unlocked) return Promise.resolve();

    return new Promise((resolve, reject) => {
      const silence = new Audio('assets/silence.mp3');
      silence.play().then(() => {
        return this.audioCtx.resume();
      }).then(() => {
        this.unlocked = true;
        console.log('Audio unlocked');
        resolve();
      }).catch(err => {
        console.error('Unlock failed', err);
        reject(err);
      });
    });
  }

  /** Plays given Blob as audio */
  public playBlob(blob: Blob, onStart?: (audioEl: HTMLAudioElement) => void): Promise<void> {
    return new Promise((resolve, reject) => {
      this.audioEl.src = URL.createObjectURL(blob);

      const cleanup = () => {
        this.audioEl.removeEventListener('ended', onEnded);
        this.audioEl.removeEventListener('error', onError);
        this.audioEl.removeEventListener('playing', onPlaying);
        URL.revokeObjectURL(this.audioEl.src);
      };

      const onEnded = () => {
        cleanup();
        resolve();
      };

      const onError = (e: Event) => {
        cleanup();
        // reject(new Error('Audio playback error'));
      };

      const onPlaying = () => {
        // Trigger waveform setup as soon as playback starts
        if (onStart) onStart(this.audioEl);
      };

      this.audioEl.addEventListener('ended', onEnded);
      this.audioEl.addEventListener('error', onError);
      this.audioEl.addEventListener('playing', onPlaying);

      this.audioEl.oncanplaythrough = () => {
        this.audioEl.play().catch(err => {
          cleanup();
          // reject(err);
        });
      };
    });
  }
}
